import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const GetVideoUploadUrlApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderSchema.required({ requestActor: true }),
    query: z.object({ labels: z.string().optional() }),
    response: z.object({
        fields: z.record(z.string(), z.string()),
        url: z.string(),
    }),
};
export const GetVideoUploadUrlRequestSchema = GetVideoUploadUrlApiSchema.params
    .merge(GetVideoUploadUrlApiSchema.headers)
    .merge(GetVideoUploadUrlApiSchema.query);
